import { useDebugValue } from 'react';
import { useConditionFieldPath } from './useConditionFieldPath';

export const useConditionComparatorFieldPath = () => {
  const conditionFieldPath = useConditionFieldPath();
  const fieldPath = `${conditionFieldPath}.comparator` as const;
  useDebugValue(fieldPath);
  return fieldPath;
};
